import { useMemo } from 'react';
import { addMonth, getLastDayOfMonth } from '../utils';

export default function useDisabledControls(
  currentMonth: Date,
  rightCalMonth: Date,
  yearsRange: {
    value: number;
    label: number;
    disabled: boolean;
  }[],
  minValue?: Date,
  maxValue?: Date,
) {
  return useMemo(() => {
    const lastDayMonth = getLastDayOfMonth(addMonth(-1, currentMonth));
    const lastYearItem = yearsRange[yearsRange.length - 1];
    const minSelectableDate = minValue || new Date(yearsRange[0].value, 0, 1);
    const maxSelectableDate = maxValue || new Date(lastYearItem.value, 11, 31);
    const disableNextMonth = addMonth(1, rightCalMonth) > maxSelectableDate;
    const disablePrevMonth = lastDayMonth < minSelectableDate;
    return [disablePrevMonth, disableNextMonth];
  }, [currentMonth, maxValue, minValue, rightCalMonth, yearsRange]);
}
